module.exports = __webpack_public_path__ + "img/about.054cd220.png";